/* eslint-disable no-param-reassign */
const updateHomeworkFromProgress = (
  homework,
  goalsProgress,
  myCourses,
  focusFive,
  memoryBoost
) => {
  const courses = homework.courses.map((course) => {
    const myCourse = myCourses.find((c) => c.course.id === course.id);
    const goals = Object.keys(myCourse?.goals ?? []).map((goalId) => ({
      id: goalId,
      isComplete: goalsProgress[goalId]?.quiz?.topScore === 100,
    }));
    const proportionComplete = Math.min(
      1,
      goals.length
        ? goals.filter((goal) => goal.isComplete).length / course.numberOfGoals
        : 0
    );

    return {
      ...course,
      goals,
      proportionComplete,
      isComplete: proportionComplete === 1,
    };
  });

  const arbitraryGoals = homework.arbitraryGoals.map((goal) => {
    const isStarted = goalsProgress[goal.id] != null;
    const isComplete = goalsProgress[goal.id]?.quiz?.topScore === 100;
    return {
      ...goal,
      // eslint-disable-next-line no-nested-ternary
      proportionComplete: isComplete ? 1 : isStarted ? 0.5 : 0,
      isComplete,
    };
  });

  homework.courses = courses;
  homework.arbitraryGoals = arbitraryGoals;

  if (focusFive) {
    updateHomeworkFromFocusFive(homework, focusFive);
  }

  if (memoryBoost) {
    updateHomeworkFromMemoryBoost(homework, memoryBoost);
  }
};

const updateHomeworkFromFocusFive = (homework, focusFive) => {
  const numPassedFocusFiveQuizzes = focusFive?.numPassedQuizzes ?? 0;

  homework.focusFive = {
    ...homework.focusFive,
    numToDo: homework.numFocusFiveGoals,
    proportionComplete: Math.min(
      1,
      homework.numFocusFiveGoals
        ? numPassedFocusFiveQuizzes / homework.numFocusFiveGoals
        : 0
    ),
  };
};

const updateHomeworkFromMemoryBoost = (homework, memoryBoost) => {
  const numPassedMemoryBoostQuizzes = memoryBoost?.numPassedQuizzes ?? 0;

  homework.memoryBoost = {
    ...homework.memoryBoost,
    numToDo: homework.numMemoryBoosts,
    proportionComplete: Math.min(
      1,
      homework.numMemoryBoosts
        ? numPassedMemoryBoostQuizzes / homework.numMemoryBoosts
        : 0
    ),
  };
};

export const updateHomeworkFromMemoryBoostQuiz = (homework, quizAttempt) => {
  const isQuizPassed =
    quizAttempt.answers.filter((a) => a.isCorrectAnswer).length ===
    quizAttempt.answers.length;

  if (isQuizPassed) {
    const numPassedMemoryBoostQuizzes =
      (homework.memoryBoost?.numPassedQuizzes ?? 0) + 1;

    homework.memoryBoost = {
      ...homework.memoryBoost,
      numToDo: homework.numMemoryBoosts,
      proportionComplete: Math.min(
        1,
        homework.numMemoryBoosts
          ? numPassedMemoryBoostQuizzes / homework.numMemoryBoosts
          : 0
      ),
    };
  }
};

export const updateHomeworkFromFocusFiveQuiz = (homework, quizAttempt) => {
  const isQuizPassed =
    quizAttempt.answers.filter((a) => a.isCorrectAnswer).length ===
    quizAttempt.answers.length;

  if (isQuizPassed) {
    const numPassedFocusFiveQuizzes =
      (homework.focusFive?.numPassedQuizzes ?? 0) + 1;

    homework.focusFive = {
      ...homework.focusFive,
      numToDo: homework.numFocusFiveGoals,
      proportionComplete: Math.min(
        1,
        homework.numFocusFiveGoals
          ? numPassedFocusFiveQuizzes / homework.numFocusFiveGoals
          : 0
      ),
    };
  }
};

export default updateHomeworkFromProgress;
